import groupBy from 'lodash/groupBy';
import { SET_UI_COLORS } from '../constants';
import Style from '../components/Style';

const DEFAULT_STATE = {
  colors: {
    dark: Style.Colors.shadow3,
    light: Style.Colors.shadow5,
    highlight: Style.Colors.shadow2,
  },
};

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_UI_COLORS:
      return {
        ...state,
        colors: {
          ...DEFAULT_STATE.colors,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ui.js